module.exports = __webpack_public_path__ + "static/media/firstline-desktop.1b0ed13f.png";